export default async (svgSource, forcedHeight = null, forcedWidth = null) => {
    return new Promise(async (resolve) => {
        const _canvas = document.createElement(`canvas`);
        const _context = _canvas.getContext(`2d`);
        const _image = new Image();
        _image.onload = function () {
            _canvas.width = this.width;
            _canvas.height = this.height;
            _context.drawImage(_image, 0, 0, this.width, this.height);
            resolve(_canvas.toDataURL(`image/png`, 1));
            _canvas.remove();
            _image.remove();
        }
        if (forcedHeight && forcedWidth) {
            _image.width = forcedWidth;
            _image.height = forcedHeight;
        }
        _image.src = svgSource;
    });
}